// @ts-ignore
import BackgroundAudio from '../assets/audio/background.mp3';
import LootAudioEffect from '../assets/audio/effect_loot.wav';
import WalkAudioEffect from '../assets/audio/walking-on-leaves-260279.mp3';
import ComputerAudioEffect from '../assets/audio/effect_computer.mp3';
import SuccessAudioEffect from '../assets/audio/effect_success.mp3'
import ConversationAudioEffect from '../assets/audio/effect_conversation.mp3';
import UnpackAudioEffect from '../assets/audio/effect_unpack.mp3';
import FireAudioEffect from '../assets/audio/effect_fire.mp3';
import EnveloppeAudioEffect from '../assets/audio/effect_enveloppe.mp3';
import BookAudioEffect from '../assets/audio/effect_book.mp3';
import MoneyAudioEffect from '../assets/audio/effect_money.mp3';
import EatAudioEffect from '../assets/audio/effect_eat.mp3';
import DrinkAudioEffect from '../assets/audio/effect_drink.mp3';
import BuyAudioEffect from '../assets/audio/effect_buy.mp3';
import FailAudioEffect from '../assets/audio/effect_fail.mp3';
import PeeAudioEffect from '../assets/audio/effect_pee.mp3';
import SleepAudioEffect from '../assets/audio/effect_sleep.mp3';
import AlarmAudioEffect from '../assets/audio/effect_alarm.mp3';
import VoiceAudioEffect from '../assets/audio/effect_voice.mp3';
import JungleAmbiance from '../assets/audio/ambiance_jungle.mp3';
import CaveBackground from '../assets/audio/background_cave.mp3';
import EmptyBackground from '../assets/audio/background_empty.mp3';

//Voices
import VoiceCaveGood from '../assets/audio/voices/voice_cave_good.mp3';
import VoiceCaveBad from '../assets/audio/voices/voice_cave_bad.mp3';
import VoiceCaveFinish from '../assets/audio/voices/voice_cave_finish.mp3';
import VoiceDrunk from '../assets/audio/voices/voice_drunk.mp3';
import VoiceHello from '../assets/audio/voices/voice_hello.mp3';
import VoiceFood from '../assets/audio/voices/voice_food.mp3';
import VoiceDrown from '../assets/audio/voices/voice_drown.mp3';
import VoiceSecondChance from '../assets/audio/voices/voice_second_chance.mp3';
import VoiceGameOver from '../assets/audio/voices/voice_game_over.mp3';

export class AudioController {

    players: any = {};
    isMuted = false;

    audioLibrary = {
        background: BackgroundAudio,
        loot: LootAudioEffect,
        walk: WalkAudioEffect,
        computer: ComputerAudioEffect,
        success: SuccessAudioEffect,
        conversation: ConversationAudioEffect,
        unpack: UnpackAudioEffect,
        fire: FireAudioEffect,
        enveloppe: EnveloppeAudioEffect,
        book: BookAudioEffect,
        money: MoneyAudioEffect,
        eat: EatAudioEffect,
        drink: DrinkAudioEffect,
        buy: BuyAudioEffect,
        error: FailAudioEffect,
        pee: PeeAudioEffect,
        sleep: SleepAudioEffect,
        alarm: AlarmAudioEffect,
        voice: VoiceAudioEffect,
        ambiance_jungle: JungleAmbiance,
        voice_cave_good: VoiceCaveGood,
        voice_cave_bad: VoiceCaveBad,
        voice_cave_finish: VoiceCaveFinish,
        voice_drunk: VoiceDrunk,
        voice_hello: VoiceHello,
        voice_food: VoiceFood,
        voice_drown: VoiceDrown,
        voice_second_chance: VoiceSecondChance,
        background_cave: CaveBackground,
        background_empty: EmptyBackground,
        voice_game_over: VoiceGameOver
    };

    constructor(){
        for(let key in this.audioLibrary){
            let audio = new Audio(this.audioLibrary[key]);
            audio.loop = false;
            this.players[key] = audio;
        }
    }

    async playAudio(key: string, volume?: number, speed?: number, loop?: boolean){
        try {
            let audio = this.players[key];
            audio.volume = volume || 1;
            audio.playbackRate = speed || 1;
            audio.loop = loop || false;
            //if(audio.)
            await audio.play();
        } catch (error) {
            console.log("MUSIC", key);
            console.log(error);
        }
    }

    pauseAudio(key: string){
        try {
            this.players[key].pause();
        } catch (error) {
            console.log(error);
        }
    }

    destroy(){
        for(let key in this.players){
            this.players[key].pause();
            this.players[key] = null;
        }
    }
}